import * as Yup from 'yup'

export const ItemPerubahanDataSchema = Yup.object().shape({
  kode_modul: Yup.string().required("Required"),
  kode_menu: Yup.string().required("Required"),
  no_referensi_transaksi: Yup.string().required("Required"),
  atribut: Yup.array().min(1, "Required")
})